import React from "react";
import Popup from "./popup";
import { useTranslation } from "react-i18next";
import { SFIcons, SFStack, SFTypography, SFLink } from "@sf-core";
import env from "env";

const TermsPolicies = (props) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {props.termsConditions && (
        <Popup
          size={"lg"}
          open
          header={t("policies.termsAndConditions.header")}
          actionAccept={props.acceptTermsConditions}
          actionDecline={props.declinePolicies}
          checkLabel={t("policies.termsAndConditions.checkLabel")}
        >
          {props.termsConditions}
        </Popup>
      )}
      {props.privacyPolicy && (
        <Popup
          size={"lg"}
          open
          header={t("policies.privacyPolicy.header")}
          actionAccept={props.acceptPrivacyPolicy}
          actionDecline={props.declinePolicies}
          checkLabel={t("policies.privacyPolicy.checkLabel")}
        >
          {props.privacyPolicy}
        </Popup>
      )}
      <Popup
        size={"lg"}
        open={props.showAccessDenied}
        header={t("policies.accessDenied.header")}
      >
        <SFStack direction="column" alignItems="flex-start" spacing={2}>
          <SFTypography>{t("policies.accessDenied.message")}</SFTypography>
          <SFLink href={`mailto:${env.REACT_APP_SUPPORT_EMAIL}`}>
            <SFStack direction="row" spacing={1}>
              <SFIcons.SFEmailIcon />
              <SFTypography>{env.REACT_APP_SUPPORT_EMAIL}</SFTypography>
            </SFStack>
          </SFLink>
        </SFStack>
      </Popup>
    </React.Fragment>
  );
};

export default TermsPolicies;
